var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"text-align":"center"}},[_c('h2',{staticStyle:{"margin-bottom":"30px"}},[_vm._v("请用微信扫码二维码注册账号")]),_c('vue-qr',{ref:"qrcode",attrs:{"text":_vm.qrtext,"size":600,"color":"#333","bg-color":"#fff"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }